import { Type } from "@angular/core";
import { PointType, Transport } from "../pages/custom-route/interfaces/custom-route.interface";
import { EditedPoint, EditedStatus } from "../pages/custom-route/shared/planner/components/edit-route/interfaces/edit-route.interface";
import { SuccessErrorEditedCustomRouteResponse, SuggestedPoint } from "../pages/custom-route/shared/planner/components/edit-route/interfaces/edit-route.response";
import { MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from "@angular/material/snack-bar";

// DIALOG INTERFACES
export interface StandardDialogData {
  iconName?: string;
  title?: string;
  content?: ContentType;
  primaryActionButtonText?: string;
  secondaryActionButtonText?: string;
  handleClickPrimaryButton?: () => void;
  handleClickSecondaryButton?: () => void;
}

export type ContentType = string | ContentDialogSuccessErrorEditRouteResponse;
export interface DialogConfig<T, D = unknown> {
  component: Type<T>;
  data?: D;
  panelClass?: string;
  enterAnimationDuration?: string;
  exitAnimationDuration?: string;
}

export interface MatDialogDetailsData {
  id: number;
  type: string;
  fromPointPlannerCustomRouteDesktop?: boolean;
}

export interface MatDialogTransportListData {
  transportList: Transport[];
  pointTitle: string;
  previousPointTitle: string;
  transportId?: number;
}

export interface ContentDialogSuccessErrorEditRouteResponse {
  errorList?: SuccessErrorEditedCustomRouteResponse[];
  successList?: SuccessErrorEditedCustomRouteResponse[];
}

// BOTTOM SHEET INTERFACES
export interface BottomSheetData {
  id?: number;
  type?: PointType;
  fromPointPlannerCustomRouteMobile?: boolean;
  fromPointPlannerCustomRouteDesktop?: boolean;
  transportList?: Transport[];
  pointTitle?: string;
  previousPointTitle?: string;
  isModal?: boolean
  defaultImg?: string
  categoryNameSlug?: string;
}

export interface MatBottomSheetAddNewPointOrReplacePointData {
  title: string;
  dayToShowIndex: number;
  orderIndex: number; 
  status: EditedStatus;
  pointToBeReplaced?: SuggestedPoint | EditedPoint;
  fromChatBot?: boolean;
  startDate?: any
}

export interface BottomSheetConfig<T, D = unknown> {
  component: Type<T>;
  data?: D;
  panelClass?: string;
}

export enum BottomSheetLevel {
  CLOSED = 0,
  MINIMIZED = 1,
  MEDIUM = 2,
  EXPANDED = 3,
};

// SNACKBAR INTERFACES
export interface MatSnackbarData {
  message: string;
  iconName?: string;
}
export interface MatSnackbarConfig<T> {
  component: Type<T>;
  data?: MatSnackbarData;
  panelClass?: string;
  duration?: number; // Duration in milliseconds
  horizontalPosition?: MatSnackBarHorizontalPosition;
  verticalPosition?: MatSnackBarVerticalPosition
}
  